import { BuscarContatos } from '@/pages/Contato/BuscarContatos';
import { ContatoDiretoria } from '@/pages/Contato/Diretoria';
import { Secoes } from '@/pages/Contato/Secoes';

import { Route, Routes } from 'react-router-dom';


const ContatoRoutes = () => {
    return (
        <Routes>
            <Route path='/buscar-contatos' element={<BuscarContatos />} />

            <Route path='/:secaoLabId' element={<Secoes />} />
            <Route path='/diretoria' element={<ContatoDiretoria />} />

        </Routes>
    )
}

export { ContatoRoutes };